module.exports = {
  __init__: [ 'zoomScroll' ],
  zoomScroll: [ 'type', require(60) ]
};